export default {
  contacts: [],
  contact: undefined,
};
